import { Container } from './style'

export function WholesaleLine() {
    return (
        <Container>
            <p>ATACADO</p>
        </Container>
    )
}
